import { Button } from '@/components/ui/button';
import { useTranslations } from '@/i18n';

interface AddCityCardProps {
  onClick?: () => void;
}

export default function AddCityCard({ onClick }: AddCityCardProps) {
  const t = useTranslations('trips.cities');

  return (
    <div className="group relative overflow-hidden rounded-2xl border-[1.5px] border-dashed border-[#bbbbbb] bg-white transition-all duration-300 hover:scale-[1.02] hover:border-[#999999] hover:shadow-sm">
      <Button
        onClick={onClick}
        variant="unstyled"
        size="none"
        className="relative z-10 flex min-h-[9.5rem] w-full flex-col items-center justify-center gap-3 px-3.5 pb-8"
      >
        {/* Plus icon button */}
        <div className="flex items-center justify-center">
          <div className="rounded-[200px] bg-[#171716] p-[6px] transition-all duration-300 group-hover:scale-110 group-hover:bg-[#292929] group-hover:shadow-md">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="transition-transform duration-300 group-hover:rotate-90"
            >
              <path
                d="M10 4V16M4 10H16"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Text */}
        <span className="text-center text-base leading-6 font-medium text-[#292929] transition-colors duration-300 group-hover:text-[#171716]">
          {t('addCity')}
        </span>
      </Button>

      {/* City buildings illustration at the bottom */}
      <div className="pointer-events-none absolute right-0 bottom-0 left-0 h-[2.8125rem]">
        <img
          src="/assets/city-buildings.svg"
          alt=""
          className="h-full w-full object-contain object-bottom"
        />
      </div>
    </div>
  );
}
